import React from "react";
import { FeildError } from "../../../component/form/form-layout";

const Step2Form = ({ formik }) => {
    // Sections aur unke questions define karenge
    const sections = [
        {
            heading: "Sales Accuracy",
            questions: [
                { text: "How well the agent understood and presented the product", field: "q1" },
                { text: "Was pricing clearly communicated?", field: "q2" },
                { text: "Deduct if any false promises or incorrect claims", field: "q3" },
            ],
        },
        {
            heading: "Customer Experience",
            questions: [
                { text: "Professional and polite tone", field: "q4" },
                { text: "Was the agent attentive to customer needs?", field: "q5" },
                { text: "How well did they handle concerns or doubts?", field: "q6" },
            ],
        },
        {
            heading: "Compliance",
            questions: [
                { text: "Did they follow internal SOPs (scripts, disclaimers)?", field: "q7" },
            ],
        },
        {
            heading: "Retention Signals",
            questions: [
                { text: "Was a frustrated client calmed down or escalated?", field: "q8" },
            ],
        },
        {
            heading: "Upsell Signals",
            questions: [
                { text: "Did they miss a good moment to upsell or cross-sell?", field: "q9" },
            ],
        },
        {
            heading: "Overall Flow",
            questions: [
                { text: "Structure, pacing, and professionalism", field: "q10" },
            ],
        },
    ];

    return (
        <div className="space-y-6 w-full p-0">
            {sections.map((section, sIdx) => (
                <div key={sIdx} className="space-y-4">
                    <h3 className="text-lg font-semibold">{section.heading}</h3>

                    {section.questions.map((q, qIdx) => (
                        <div key={qIdx} className="space-y-2">
                            <label className="font-medium">{q.text}</label>

                            {/* 1–10 rating buttons */}
                            <div className="flex gap-2">
                                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((n) => (
                                    <button
                                        key={n}
                                        type="button"
                                        className={`w-8 h-8 flex items-center justify-center border rounded-md ${formik.values.salesAccuracy[q.field] === n
                                            ? "bg-blue-500 text-white"
                                            : "bg-white text-gray-800 border-gray-300"
                                            }`}
                                        onClick={() => {
                                            formik.setFieldValue(`salesAccuracy.${q.field}`, n);
                                            formik.setFieldTouched(`salesAccuracy.${q.field}`, true);
                                        }}
                                    >
                                        {n}
                                    </button>
                                ))}
                            </div>



                            {formik?.touched?.salesAccuracy?.[q.field] &&
                                !formik.values.salesAccuracy?.[q.field] && (
                                    <FeildError className="!mt-2">This field is required</FeildError>
                                )}

                            {/* Note textarea */}
                            <textarea
                                placeholder="Add notes..."
                                className="w-full border border-gray-300 rounded-md p-2 text-sm"
                                rows={2}
                                value={formik.values.salesAccuracy[`${q.field}_note`] || ""}
                                onChange={(e) =>
                                    formik.setFieldValue(`salesAccuracy.${q.field}_note`, e.target.value)
                                }
                            />
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
};

export default Step2Form;
